import React from "react";

export default function OverviewPanel({ totalNodes, lastUpdated }) {
  const updatedText = lastUpdated
    ? new Date(lastUpdated).toLocaleTimeString()
    : "--";

  return (
    <div className="panel overview-panel">
      <div className="panel-title">Fleet Overview</div>
      <div className="panel-sub">
        Real-time status for all registered edge devices.
      </div>
      <div className="stat-grid">
        <div className="stat-card">
          <div className="stat-label">Registered Nodes</div>
          <div className="stat-value">{totalNodes}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Last Sync</div>
          <div className="stat-value">{updatedText}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Status</div>
          <div className="stat-value">Awaiting selection</div>
        </div>
      </div>
      <div className="callout">
        Select an edge node to unlock traffic shaping and diagnostics.
      </div>
    </div>
  );
}
